import { render, staticRenderFns } from "./hotCourseCard.vue?vue&type=template&id=d89b3b2e&scoped=true&"
import script from "./hotCourseCard.vue?vue&type=script&lang=js&"
export * from "./hotCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./hotCourseCard.vue?vue&type=style&index=0&id=d89b3b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89b3b2e",
  null
  
)

export default component.exports